var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title_wrap"},[_c('div',{staticClass:"botline"}),_c('div',{staticClass:"left_txt"},[_c('img',{attrs:{"src":require("../../assets/img/layout/maintitlelogo.png")}}),_c('span',[_vm._v(_vm._s(_vm.val))])]),_c('div',{staticClass:"right_cont"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }